import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { cn, itemListProps } from '@restworld/utils-common';

import { JobOfferBenefits } from '../../';
import { Heading } from '@restworld/ui-ds-base';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import LongParagraph from '../../design-system/long-paragraph';

export interface JobContractProps {
  contractContent: string;
  jobBenefits?: itemListProps[];
}

export const JobContract = ({ contractContent, jobBenefits }: JobContractProps) => {
  const { t } = useTranslation('common');

  return (
    <Wrapper>
      {contractContent ? (
        <>
          <span className="flex items-center gap-1">
            <DocumentTextIcon className="h-6 w-6" />
            <Heading size={4} weight="semibold">
              {t('contract_title')}
            </Heading>
          </span>
          <LongParagraph
            content={contractContent}
            isHtml
            maxLength={450}
            title={t('contract_title')}
            headerIcon="DocumentTextIcon"
            btnTitle={t('keep_on_reading')}
            noSlice
          />
        </>
      ) : null}
      {jobBenefits?.length ? <JobOfferBenefits jobBenefits={jobBenefits} /> : null}
    </Wrapper>
  );
};
export default JobContract;
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-4', className)} {...props} />
);
